module.exports = __webpack_public_path__ + "img/avatar-s-26.fda3c31e.jpg";